function checkoutErrorMessageKey(error: unknown): string {
  if (error instanceof Error && error.message === 'unableToProcessPayment') {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  return 'unableToOpenCheckout';
}

function getDescriptionForErrorMessage(errorMessage: string): string {
  switch (errorMessage) {
    case 'unableToOpenCheckout':
      return 'pleaseTryAgainInAMoment';
    case 'unableToProcessPayment':
      return 'pleaseReopenTheCheckoutAndTryAgain';
    default:
      return 'pleaseTryAgainInAMoment';
  }
}

export { checkoutErrorMessageKey, getDescriptionForErrorMessage };
